import { render, staticRenderFns } from "./SearchSummary.vue?vue&type=template&id=69a65d6a"
import script from "./SearchSummary.vue?vue&type=script&lang=js"
export * from "./SearchSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports